module.exports = __webpack_public_path__ + "static/media/sanpedro.121d68fa.jpeg";